export const DEFAULT_ZOOM = 1;
export const ZOOM_MIN = 0.5;
export const ZOOM_MAX = 5;
export const ZOOM_STEP = 0.05;
export const ZOOM_VAR = '--sc-preview-zoom';
export const ZOOM_VAR_INVERSE = '--sc-preview-zoom-inverse';
